<template>
  <div class="report">
    <tk-flex v-if="isShowTop && isShowPrint" middle between>
      <div class="font-bold font-16">粮虫报表</div>
      <a-button type="primary" @click="print">打印</a-button>
    </tk-flex>
    <div id="print" style="padding-top: 20px">
      <div
        v-if="isShowTop"
        class="height-full grid bg-white bg-white items-center"
        style="height: 60px; grid-template-columns: 1fr auto 1fr; gap: 15px"
      >
        <div class="left"></div>
        <div
          class="title"
          style="font-size: 16px;
      font-weight: 600;"
        >
          粮情数据报表
        </div>
        <tk-flex class="right justify-self-end" middle>
          后缀<maxSvg />代表最高值
          <!-- ，后缀<minSvg />代表最低值 -->
        </tk-flex>
      </div>
      <a-descriptions
        v-if="isShowTop"
        size="small"
        class="descriptions"
        bordered
        :column="4"
      >
        <a-descriptions-item label="粮虫报表"> 粮食害虫 </a-descriptions-item>
        <a-descriptions-item label="粮虫状态"> 活动粮虫 </a-descriptions-item>
        <a-descriptions-item label="数据来源"> 虫情系统 </a-descriptions-item>
        <a-descriptions-item label="仓库方向"> 北 </a-descriptions-item>
        <a-descriptions-item label="活虫预警">
          发现活动粮虫
        </a-descriptions-item>
        <a-descriptions-item label="检测时间">
          {{ time1 }}
        </a-descriptions-item>
        <a-descriptions-item v-if="isCompared" label="对比时间">
          {{ time2 }}
        </a-descriptions-item>
        <a-descriptions-item v-else label="天气状况"> -- </a-descriptions-item>
        <a-descriptions-item label="数量单位"> 只 </a-descriptions-item>
      </a-descriptions>
      <div v-if="isShowTop" class="flex custom-table">
        <div class="title table-left">
          <div class="title">粮虫种类</div>
          <div>粮虫数量</div>
          <div>粮虫密度</div>
        </div>
        <div class="flex flex-1 table-right">
          <div class="flex-1">
            <div class="title">象甲科</div>
            <div>--</div>
            <div>--</div>
          </div>
          <div class="flex-1">
            <div class="title">拟步甲科</div>
            <div>--</div>
            <div>--</div>
          </div>
          <div class="flex-1">
            <div class="title">飞蚁科</div>
            <div>--</div>
            <div>--</div>
          </div>
          <div class="flex-1">
            <div class="title">飞蛾科</div>
            <div>--</div>
            <div>--</div>
          </div>
          <div class="flex-1">
            <div class="title">飞蛾幼虫类</div>
            <div>--</div>
            <div>--</div>
          </div>
          <div class="flex-1">
            <div class="title">书虱</div>
            <div>--</div>
            <div>--</div>
          </div>
          <div class="flex-1">
            <div class="title">其他害虫</div>
            <div>--</div>
            <div>--</div>
          </div>
          <div class="flex-1">
            <div class="title">总计</div>
            <div>{{ storeBugNum }}</div>
            <div>--</div>
          </div>
        </div>
      </div>
      <div v-for="(item, index) in list" :key="index" class="flex custom-table">
        <div class="title table-left">
          <div class="title">点位编号</div>
          <div>总计</div>
        </div>
        <div class="flex flex-1 table-right">
          <div
            v-for="(itm, idx) in item"
            :key="idx"
            :style="{ width: `calc(100% / ${rowNum})` }"
          >
            <div class="title">{{ itm.num }}</div>
            <div class="flex justify-center items-center">
              {{ itm.count }}
              <maxSvg v-show="isShowTips && itm.show === 'max'" />
              <!-- <minSvg v-show="isShowTips && itm.show === 'min'" /> -->
            </div>
          </div>
          <div v-show="item.length !== rowNum" class="flex-1">
            <div class="title"><span style="opacity: 0">1</span></div>
            <div><span style="opacity: 0">1</span></div>
          </div>
        </div>
      </div>
      <slot></slot>
    </div>
  </div>
</template>

<script>
import MaxSvg from './maxSvg'
import printJS from 'print-js'
import html2canvas from 'html2canvas'
import canvas2Image from '../../utils/canvas2Image.js'

// import MinSvg from './minSvg'
export default {
  components: {
    MaxSvg
    // MinSvg
  },
  props: {
    isShowPrint: {
      type: Boolean,
      default: true
    },
    isShowTips: {
      type: Boolean,
      default: true
    },
    isShowTop: {
      type: Boolean,
      default: true
    },
    storeBugNum: {
      type: Number,
      required: true
    },
    originalList: {
      type: Array,
      required: true
    },
    isCompared: {
      type: Boolean,
      default: false
    },
    time1: {
      type: String,
      required: true
    },
    time2: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      list: [],
      rowNum: 20, // 一行多少个
      screenWidth: 0
    }
  },
  computed: {
    showList () {
      const arr = []
      let maxindex = []
      // let minindex = []
      let max = Number.MIN_SAFE_INTEGER
      // let min = Number.MAX_SAFE_INTEGER

      this.originalList.forEach((element, index) => {
        if (element.origin.hasResult) {
          if (element.count > max) {
            max = element.count
            maxindex = [index]
          } else if (element.count === max) {
            maxindex.push(index)
          }
          // if (element.count < min) {
          //   min = element.count
          //   minindex = [index]
          // } else if (element.count === min) {
          //   minindex.push(index)
          // }
        } else {
          element.count = '--'
        }
        arr.push(element)
      })
      if (maxindex.length > 0) {
        maxindex.forEach(element => {
          arr[element].show = 'max'
        })
      }
      // if (minindex.length > 0) {
      //   minindex.forEach(element => {
      //     arr[element].show = 'min'
      //   })
      // }
      return arr
    }
  },
  watch: {
    screenWidth () {
      if (this.screenWidth > 1900) {
        this.rowNum = 24
      } else if (this.screenWidth > 1515) {
        this.rowNum = 16
      } else if (this.screenWidth > 1272) {
        this.rowNum = 16
      } else if (this.screenWidth > 1031) {
        this.rowNum = 14
      } else if (this.screenWidth < 1031) {
        this.rowNum = 14
      }
      this.arrange()
    },
    showList (newV) {
      this.arrange()
    }
  },
  mounted () {
    this.screenWidth = document.getElementsByClassName('report')[0].offsetWidth
    window.addEventListener('resize', this.undateScreenWidth)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.undateScreenWidth)
  },
  methods: {
    undateScreenWidth () {
      this.screenWidth = document.getElementsByClassName('report')[0].offsetWidth
    },
    arrange () {
      let list = []
      let arr = []
      for (let i in this.showList) {
        arr.push(this.showList[i])
        if (arr.length === this.rowNum) {
          list.push(arr)
          arr = []
        }
      }
      if (arr.length > 0) {
        list.push(arr)
      }
      this.list = list
    },
    print () {
      // this.printByStyle()
      this.printByImage()
      // this.printByBrower()
    },
    printByImage () {
      html2canvas(document.getElementById('print')).then((canvas) => {
        // document.body.innerHTML = ''
        // document.body.appendChild(canvas)
        const images = canvas2Image.convertToJPEG(canvas, canvas.width, canvas.height)
        // document.body.innerHTML = ''
        // document.body.appendChild(images)
        printJS({
          printable: images.src,
          type: 'image',
          base64: true,
          documentTitle: '',
          style: `@media print { @page {size: auto; margin: 0; } body{margin:0 30px;}}`
        })
      })
    },
    printByBrower () {
      // 缓存页面内容
      const bodyHtml = window.document.body.innerHTML
      // 获取要打印的dom
      const printContentHtml = document.getElementById('print').innerHTML
      // 替换页面内容
      window.document.body.innerHTML = printContentHtml
      // 全局打印
      window.print()
      // 还原页面内容
      window.document.body.innerHTML = bodyHtml
      // 页面事件会丢失，需要刷新
      window.location.reload()
    },
    printByStyle () {
      printJS({
        printable: 'print',
        type: 'html',
        maxWidth: 1200,
        targetStyle: ['*'],
        targetStyles: ['*'],
        documentTitle: '',
        scanStyles: true
        //         style: `
        //         .ant-descriptions-title {
        //   margin-bottom: 20px;
        //   color: #363B45;
        //   font-weight: bold;
        //   font-size: 16px;
        //   line-height: 1.5;
        // }
        // .ant-descriptions-view {
        //   width: 100%;
        //   overflow: hidden;
        //   border-radius: 8px;
        // }
        // .ant-descriptions-view table {
        //   width: 100%;
        //   table-layout: fixed;
        // }
        // .ant-descriptions-row > th,
        // .ant-descriptions-row > td {
        //   padding-bottom: 16px;
        // }
        // .ant-descriptions-row:last-child {
        //   border-bottom: none;
        // }
        // .ant-descriptions-item-label {
        //   color: #363B45;
        //   font-weight: normal;
        //   font-size: 14px;
        //   line-height: 1.5;
        // }
        // .ant-descriptions-item-label::after {
        //   position: relative;
        //   top: -0.5px;
        //   margin: 0 8px 0 2px;
        //   content: ' ';
        // }
        // .ant-descriptions-item-colon::after {
        //   content: ':';
        // }
        // .ant-descriptions-item-no-label::after {
        //   margin: 0;
        //   content: '';
        // }
        // .ant-descriptions-item-content {
        //   display: table-cell;
        //   color: #666A70;
        //   font-size: 14px;
        //   line-height: 1.5;
        // }
        // .ant-descriptions-item {
        //   padding-bottom: 0;
        // }
        // .ant-descriptions-item > span {
        //   display: inline-block;
        // }
        // .ant-descriptions-middle .ant-descriptions-row > th,
        // .ant-descriptions-middle .ant-descriptions-row > td {
        //   padding-bottom: 12px;
        // }
        // .ant-descriptions-small .ant-descriptions-row > th,
        // .ant-descriptions-small .ant-descriptions-row > td {
        //   padding-bottom: 8px;
        // }
        // .ant-descriptions-bordered .ant-descriptions-view {
        //   border: 1px solid #e8e8e8;
        // }
        // .ant-descriptions-bordered .ant-descriptions-view > table {
        //   table-layout: auto;
        // }
        // .ant-descriptions-bordered .ant-descriptions-item-label,
        // .ant-descriptions-bordered .ant-descriptions-item-content {
        //   padding: 16px 24px;
        //   border-right: 1px solid #e8e8e8;
        // }
        // .ant-descriptions-bordered .ant-descriptions-item-label:last-child,
        // .ant-descriptions-bordered .ant-descriptions-item-content:last-child {
        //   border-right: none;
        // }
        // .ant-descriptions-bordered .ant-descriptions-item-label {
        //   background-color: #fafafa;
        // }
        // .ant-descriptions-bordered .ant-descriptions-item-label::after {
        //   display: none;
        // }
        // .ant-descriptions-bordered .ant-descriptions-row {
        //   border-bottom: 1px solid #e8e8e8;
        // }
        // .ant-descriptions-bordered .ant-descriptions-row:last-child {
        //   border-bottom: none;
        // }
        // .ant-descriptions-bordered.ant-descriptions-middle .ant-descriptions-item-label,
        // .ant-descriptions-bordered.ant-descriptions-middle .ant-descriptions-item-content {
        //   padding: 12px 24px;
        // }
        // .ant-descriptions-bordered.ant-descriptions-small .ant-descriptions-item-label,
        // .ant-descriptions-bordered.ant-descriptions-small .ant-descriptions-item-content {
        //   padding: 8px 16px;
        // }

        // .descriptions[data-v-6446c320]  .ant-descriptions-view {
        //   border-radius: 8px 8px 0 0;
        // }
        // .descriptions[data-v-6446c320]  .ant-descriptions-view .ant-descriptions-item-label {
        //   font-weight: 600;
        //   text-align: center;
        // }
        // .custom-table[data-v-6446c320] {
        //   color: #363b45;
        //   text-align: center;
        // }
        // .custom-table .table-left[data-v-6446c320] {
        //   border-left: 1px solid #e8e8e8;
        //   border-right: 1px solid #e8e8e8;
        //   width: 107px;
        //   -ms-flex-negative: 0;
        //       flex-shrink: 0;
        // }
        // .custom-table .table-left div[data-v-6446c320] {
        //   padding: 8px 0;
        //   border-bottom: 1px solid #e8e8e8;
        // }
        // .custom-table .table-right > div[data-v-6446c320] {
        //   border-right: 1px solid #e8e8e8;
        // }
        // .custom-table .table-right > div div[data-v-6446c320] {
        //   padding: 8px 0;
        //   border-bottom: 1px solid #e8e8e8;
        // }
        // .custom-table .title[data-v-6446c320] {
        //   font-weight: 600;
        //   background: #fafafa;
        // }
        // .report[data-v-6446c320] {
        //   background: #fff;
        // }
        // .report .reportTitle[data-v-6446c320] {
        //   padding: 14px 0;
        //   text-align: center;
        //   display: -webkit-box;
        //   display: -ms-flexbox;
        //   display: flex;
        //   -webkit-box-pack: justify;
        //       -ms-flex-pack: justify;
        //           justify-content: space-between;
        //   -webkit-box-align: center;
        //       -ms-flex-align: center;
        //           align-items: center;
        // }
        // .report .reportTitle .title[data-v-6446c320] {
        //   font-size: 16px;
        //   font-weight: 600;
        // }
        // .report .reportTitle .right[data-v-6446c320] {
        //   font-size: 12px;
        // }
        //         `
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.descriptions {
  ::v-deep .ant-descriptions-view {
    border-radius: 8px 8px 0 0;
    .ant-descriptions-item-label {
      font-weight: 600;
      text-align: center;
    }
    // .ant-descriptions-item-content {
    //   // text-align: center;
    // }
  }
}
.custom-table {
  color: #363b45;
  text-align: center;
  .table-left {
    border-left: 1px solid #e8e8e8;
    border-right: 1px solid #e8e8e8;
    width: 107px;
    flex-shrink: 0;
    div {
      padding: 8px 0;
      border-bottom: 1px solid #e8e8e8;
    }
  }
  .table-right {
    > div {
      border-right: 1px solid #e8e8e8;
      div {
        padding: 8px 0;
        border-bottom: 1px solid #e8e8e8;
      }
    }
  }
  .title {
    font-weight: 600;
    background: #fafafa;
  }
}
.report {
  background: #fff;
  .reportTitle {
    padding: 14px 0;
    text-align: center;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .title {
      font-size: 16px;
      font-weight: 600;
    }
    .right {
      font-size: 12px;
    }
  }
}
</style>
